export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/chevron-up-add929a8eaf7f8a6af0a182a326c3a2e.svg";